import { Component, EventEmitter, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
   selector: 'app-invoice-viewer',
   templateUrl: './invoice-viewer.component.html',
   styleUrls: ['./invoice-viewer.component.scss']
})
export class InvoiceViewerComponent {
   pdfUrl: any;
   download = new EventEmitter();

   constructor(@Inject(MAT_DIALOG_DATA) public data: any, sanitizer: DomSanitizer) {
      const url = `assets/pdfjs/web/viewer.html?file=${encodeURIComponent(data.url)}#zoom=100`;
      this.pdfUrl = sanitizer.bypassSecurityTrustResourceUrl(url);
   }
}
